/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LinkRowItem_viewer$ref: FragmentReference;
export type LinkRowItem_viewer = {|
  +doNotShowPrivacyPolicyAlerts: ?boolean,
  +$refType: LinkRowItem_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "LinkRowItem_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "doNotShowPrivacyPolicyAlerts",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "doNotShowPrivacyPolicyAlerts",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"doNotShowPrivacyPolicyAlerts\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '61e53641ebff633fb1a94eb516457887';
module.exports = node;
